import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { BiPageHeader } from '@euler/app/flows/bi-dashboards/components/ui/BiPageHeader';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiPalette, kBiDefaultPalette } from '@euler/model/bi/viz';
import { ReactNode, memo, useState } from 'react';
import { ScrollView, View } from 'react-native';
import { BiGalleryWidth, kBiGalleryWidths } from '../functions/biGalleryWidth';
import { PreviewFrame } from './PreviewFrame';
import { GalleryToolbar } from './toolbar/GalleryToolbar';

/**
 * A gallery page: the header with the palette and width controls, and the
 * content laid out at the chosen width in the chosen palette.
 */
export const GalleryLayout = memo(
  ({
    title,
    onBack,
    children,
  }: {
    title: string;
    onBack: () => void;
    children: (frame: { width: number; palette: BiPalette }) => ReactNode;
  }) => {
    const { rpx } = useResponsiveContext();
    const [palette, setPalette] = useState<BiPalette>(kBiDefaultPalette);
    const [width, setWidth] = useState(BiGalleryWidth.Desktop);
    return (
      <View style={{ flex: 1, backgroundColor: aiColors.background }}>
        <BiPageHeader title={title} onBack={onBack}>
          <GalleryToolbar
            palette={palette}
            width={width}
            onPalette={setPalette}
            onWidth={setWidth}
          />
        </BiPageHeader>
        <ScrollView
          style={{ flex: 1 }}
          contentContainerStyle={{
            paddingVertical: rpx(16),
            paddingBottom: rpx(40),
          }}
        >
          <PreviewFrame maxWidth={kBiGalleryWidths[width].px}>
            {frameWidth => children({ width: frameWidth, palette })}
          </PreviewFrame>
        </ScrollView>
      </View>
    );
  },
);
